// Copyright 2018 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { VideoFrame } from "datatypes/SoramaLocalApi";
import { GenericMeasurement, MeasurementPartType } from "datatypes/SoramaWebApi";
import { buildQueryString } from "extensions/UriExtensions";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler, WebRequestPriority } from "libraries/WebRequestHandler/IWebRequestHandler";
import { IMeasurementVideoFileService } from "services/Storage/IMeasurementVideoFileService";

@autoinject
export class CloudVideoFileService implements IMeasurementVideoFileService {
    private webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler) {
        this.webRequestHandler = webRequestHandler;
    }

    public getVideoFrames(
        measurement: GenericMeasurement,
        partIndex?: number,
        callback?: (progress: number) => void,
        startTime?: number,
        duration?: number
    ): Promise<VideoFrame[][]> {
        const queryString = buildQueryString({ startTime: startTime, duration: duration });

        // Get video parts requested
        const promises: Promise<VideoFrame[]>[] = [];
        if (partIndex !== undefined && partIndex !== null) {
            if (partIndex >= measurement.parts.length || partIndex < 0)
                return Promise.reject("Part index is out of range");

            if (measurement.parts[partIndex].measurementType !== MeasurementPartType.Video)
                return Promise.reject("Measurement part is not of video type");

            promises.push(
                this.webRequestHandler
                    .createGetRequest<VideoFrame[]>(
                        Api.video + "/" + measurement.id + "/" + partIndex + "/Frames" + queryString
                    )
                    .withPriority(WebRequestPriority.LowPriority)
                    .send()
                    .then((x) => x.content)
            );
        } else {
            for (let i = 0; i < measurement.parts.length; i++) {
                if (measurement.parts[i].measurementType == MeasurementPartType.Video) {
                    promises.push(
                        this.webRequestHandler
                            .createGetRequest<VideoFrame[]>(
                                Api.video + "/" + measurement.id + "/" + i + "/Frames" + queryString
                            )
                            .withPriority(WebRequestPriority.LowPriority)
                            .send()
                            .then((x) => x.content)
                    );
                }
            }
        }

        // Wait for all to finish
        return Promise.all(promises).catch(() => {
            throw new Error("Video data is not available");
        });
    }
}
